import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminAuthors from "@/pages/admin/AdminAuthors";

export const Route = createFileRoute("/admin/authors")({
  component: () => (
    <ProtectedRoute>
      <AdminAuthors />
    </ProtectedRoute>
  ),
});
